import { Component, OnInit } from '@angular/core';
import { User } from '../shared/models/user';
import { UserService } from '../shared/services/user.service';
import { Router } from '@angular/router';
import * as AOS from 'aos';
import {Title } from "@angular/platform-browser";

@Component({
  selector: 'app-ourteam',
  templateUrl: './ourteam.component.html',
  styleUrls: ['./ourteam.component.css']
})

export class OurteamComponent implements OnInit {

  users: User[];
  order:string='MemberId';
  constructor(
    private service: UserService,
    public router: Router,
    private titleService: Title,
  ) { }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle("Our Team - SFI Compliance, Inc");
    AOS.init();

    //console.log(this.users);

    await this.service.getUsers().then(userData=>{      
      //userData.sort(function(a, b){return a.id-b.id});
      //console.log("sorted userdata"+userData);
      this.users=userData;
      console.log(this.users);
    })
  }

  goToDetailsPage(id : number) : void {
    this.router.navigateByUrl("/teamdetail/"+id);
  }
}
